/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import {
  BrowserRouter as Router, Route, Link, Switch,
} from 'react-router-dom';
import './App.css';
import Admin from './components/Admin';
import Music from './components/Music';
import About from './components/About';
import Medical from './components/Medical';
import GuestBook from './components/GuestBook';
import NoMatch from './components/NoMatch';
import Footer from './components/Footer';

const optionMappings = {
  'Guest Book': 'guestbook',
  Jazz: 'jazz',
  Medicine: 'medicine',
  About: '',
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeComponent: null,
    };
    this.setActiveComponent = this.setActiveComponent.bind(this);
  }

  async componentDidMount() {
    const res = await axios.get('/api/user');
    if (_.get(res, 'data.isLoggedIn')) {
      window.sessionStorage.setItem('isLoggedIn', 'true');
    } else {
      window.sessionStorage.removeItem('isLoggedIn');
    }
  }

  setActiveComponent(option) {
    this.setState({ activeComponent: option });
  }

  render() {
    const options = ['About', 'Jazz', 'Medicine', 'Guest Book'];
    const { activeComponent } = this.state;

    return (
      <Router>
        <div className="App">
          <div id="header-wrapper">
            <div id="name-header">
              <div className="photo-wrapper">
                <img className="header-photo" src="https://hrf-bucket.s3.amazonaws.com/Bethpage+Black.jpg" />
              </div>
              <div className="name">Harrison R. Ferlauto, M.D.</div>
              <div className="photo-wrapper">
                <img className="header-photo right" src="https://hrf-bucket.s3.amazonaws.com/Bethpage+Black.jpg" />
              </div>
            </div>
            <div id="navbar">
              {options.map((option) => {
                const className = `option${option === activeComponent ? ' active' : ''}`;
                return (
                  <Link
                    className={className}
                    key={option}
                    to={`/${optionMappings[option]}`}
                  >
                    {option}
                  </Link>);
              })}
            </div>
          </div>
          <div id="content-wrapper">
            <Switch>
              <Route path="/" exact render={() => <About setActiveComponent={this.setActiveComponent} />} />
              <Route path="/medicine" render={() => <Medical setActiveComponent={this.setActiveComponent} />} />
              <Route path="/jazz" render={() => <Music setActiveComponent={this.setActiveComponent} />} />
              <Route path="/guestbook" render={() => <GuestBook setActiveComponent={this.setActiveComponent} />} />
              <Route path="/admin/" component={Admin} />
              <Route component={NoMatch} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
